// Merge in the ItemRecord for any items that changed
const mergeChangedSuperAndChildren = (state, newSuperAndChildrenById, prevSuperAndChildrenById) => {
  const changedItems = newSuperAndChildrenById.filter((s, id) => s !== prevSuperAndChildrenById.get(id));

  return state.withMutations(s => {
    changedItems.forEach((c, cId) => {
      s.update(cId, d => d.merge(c.toObject()));
    });
  });
};

export default mergeChangedSuperAndChildren;
